module.exports = __webpack_public_path__ + "img/swans.caf2e26.png";